import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
  || 'https://valqvrelorynwvfzzjci.supabase.co'

const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY
  || 'sb_publishable_dd7V2Tq_A36hrKfr_kdBCw_7AAfwD_o'

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase credentials')
}

export const supabase = createClient(supabaseUrl, supabaseKey)